export default __webpack_public_path__ + "static/media/VolkswagenBG.6033fbf9.png";